__turbopack_context__.v({
  "className": "fontsans_7faeb67a-module__o6lWPq__className",
  "variable": "fontsans_7faeb67a-module__o6lWPq__variable",
});
